import { Converter } from '@spartacus/core';
import { InjectionToken } from '@angular/core';
import { LoyaltyInterface } from '@app/custom/features/rrs-account/models/loyalty.model';

export const LOYALTY_NORMALIZER = new InjectionToken<
  Converter<any, LoyaltyInterface>
>('LoyaltyNormalizer');
